import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StrictMode } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider as StoreProvider } from "react-redux";
import { renderRoutes } from "react-router-config";
import { HashRouter } from "react-router-dom";
import { store } from "@jti/store";
import { InsertGoogleRecaptcha, LocaleContext, PopperProvider, Toaster } from "@jti/ui";
import { CampaignRunner } from "../../components/CampaignRunner";
import { CountrySetter } from "../../components/CountrySetter";
import { AemModelProvider } from "../../contexts";
import { setGlobalStore } from "../../utils/globalStore";
import { routes } from "./routes";
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
});
setGlobalStore(store);
export const StandardCheckoutApp = ({ aemModel }) => {
    return (_jsxs(StrictMode, { children: [_jsx(InsertGoogleRecaptcha, {}), _jsx(StoreProvider, { store: store, children: _jsx(LocaleContext.Provider, { value: "en-US", children: _jsx(PopperProvider, { children: _jsx(AemModelProvider, { model: aemModel, children: _jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(Toaster, {}), _jsx(CampaignRunner, {}), _jsx(CountrySetter, {}), _jsx(HashRouter, { children: renderRoutes(routes) })] }) }) }) }) })] }));
};
//# sourceMappingURL=StandardCheckoutApp.js.map